var _path, _g, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfirmation2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 72,
    viewBox: "0 0 104 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.1428 28.2857C96.5017 58.4465 71.9294 72 52.5559 72C33.1825 72 8 55.7095 8 38.359C8 21.0086 12.6244 10.2043 32.1126 3.51391C51.6008 -3.1765 91.784 -1.87508 94.1428 28.2857Z",
    fill: "#F7F7FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_113_114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.3825 18.1087C50.8094 17.2258 52.6128 17.2258 54.0397 18.1087L72.7832 29.706C73.2692 30.0067 73.5649 30.5375 73.5649 31.1091V31.1091C73.5649 31.7301 73.2162 32.2986 72.6626 32.5799L51.7111 43.2285L30.7596 32.5799C30.206 32.2986 29.8573 31.7301 29.8573 31.1091V31.1091C29.8573 30.5375 30.1531 30.0067 30.6391 29.706L49.3825 18.1087Z",
    fill: "#B1B0F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6237 19.3646C32.6237 18.1422 33.6146 17.1512 34.837 17.1512H68.1311C69.3535 17.1512 70.3445 18.1422 70.3445 19.3646V40.5528C70.3445 41.7752 69.3535 42.7662 68.1311 42.7662H34.837C33.6146 42.7662 32.6237 41.7752 32.6237 40.5528V19.3646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.6841,
    y: 26.334,
    width: 27.6006,
    height: 2.41651,
    rx: 1.20825,
    fill: "#E6E5FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.6841,
    y: 31.167,
    width: 27.6006,
    height: 2.41651,
    rx: 1.20825,
    fill: "#E6E5FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.6841,
    y: 36,
    width: 27.6006,
    height: 2.41651,
    rx: 1.20825,
    fill: "#E6E5FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.6841,
    y: 21.5009,
    width: 10.5802,
    height: 2.41651,
    rx: 1.20825,
    fill: "#8E8CEE"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8639 31.8057C29.8639 30.1707 31.5756 29.1001 33.0457 29.8155L50.7459 38.4285C51.3573 38.726 52.0715 38.726 52.6828 38.4285L70.383 29.8155C71.8531 29.1001 73.5648 30.1707 73.5648 31.8057V52.6353C73.5648 53.8578 72.5739 54.8487 71.3515 54.8487H32.0773C30.8549 54.8487 29.8639 53.8578 29.8639 52.6353V31.8057Z",
    fill: "#B1B0F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3836 40.8266C50.8116 39.9422 52.6171 39.9422 54.0452 40.8266L73.5648 52.9155V52.9155C73.5648 53.9832 72.6993 54.8487 71.6316 54.8487H31.7971C30.7294 54.8487 29.8639 53.9832 29.8639 52.9155V52.9155L49.3836 40.8266Z",
    fill: "#C9C8FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14638 17.704C7.37038 16.392 9.19438 14.944 10.6184 13.36C12.0424 11.776 12.7544 10.248 12.7544 8.776C12.7544 7.992 12.5064 7.368 12.0104 6.904C11.5304 6.424 10.8504 6.184 9.97038 6.184C9.13838 6.184 8.43438 6.344 7.85838 6.664C7.29838 6.968 6.74638 7.368 6.20238 7.864L5.29038 6.544C5.61038 6.144 6.06638 5.736 6.65838 5.32C7.26638 4.904 7.97038 4.56 8.77038 4.288C9.57038 4 10.3784 3.856 11.1944 3.856C12.3624 3.856 13.3384 4.056 14.1224 4.456C14.9224 4.856 15.5144 5.384 15.8984 6.04C16.2824 6.696 16.4744 7.424 16.4744 8.224C16.4744 9.76 15.7384 11.304 14.2664 12.856C12.7944 14.408 10.9224 15.832 8.65038 17.128L15.6104 16.48L16.5224 14.464L18.0344 14.776L17.3384 19H5.65038L5.14638 17.704Z",
    fill: "#8E8CEE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_113_114",
    x: 1.8573,
    y: -8.84879,
    width: 99.7076,
    height: 82.0773,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.380392 0 0 0 0 0.376471 0 0 0 0 0.635294 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_113_114"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_113_114",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmation2);
export default __webpack_public_path__ + "static/media/confirmation2.9d03b4a883fcd82872c71084f71927b8.svg";
export { ForwardRef as ReactComponent };